export let dataProps = {
    id: 0,
    staff_id: null,
    leave_id: null,
    date_range: '',
    reason_for_leave: '',
    leave_status: 0,
    status_updated_by_staff_id: 0,
    status_updater_notes: '',
    paid_leave: false
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveApplication/properties.js